export enum FlightExchangeStateEnum {
  cartRebookFailed = "cartRebookFailed",
}

export const FlightExchangeState = {
  ...FlightExchangeStateEnum,
};
